import SiteHeader from './SiteHeaderDesktop';
import SiteHeaderContainer from './SiteHeaderDesktop.container';
export default SiteHeaderContainer(SiteHeader);
